var _style, _circle, _defs, _path, _defs2, _path2, _defs3, _polygon, _defs4, _polygon2, _defs5, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _path3, _path4, _path5, _path6, _path7, _defs6, _polygon8, _defs7, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _path8, _path9, _path10, _path11, _path12, _defs8, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _path13, _path14, _path15, _path16, _path17, _defs9, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _path18, _path19, _path20, _path21, _path22, _defs10, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _path23, _path24, _path25, _path26, _path27, _defs11, _path28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _path29, _path30, _path31, _path32, _path33, _defs12, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39, _path34, _path35, _path36, _path37, _path38, _defs13, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _path39, _path40, _path41, _path42, _path43, _defs14, _polygon45, _polygon46, _polygon47, _polygon48, _polygon49, _path44, _path45, _path46, _path47, _path48, _defs15, _polygon50, _polygon51, _polygon52, _polygon53, _polygon54, _path49, _path50, _path51, _path52, _path53, _defs16, _path54, _polygon55, _polygon56, _polygon57, _polygon58, _polygon59, _polygon60, _path55, _path56, _path57, _path58, _path59, _defs17, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServiceElectreIllu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 800",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n\t.st1{clip-path:url(#SVGID_3_);fill:#244283;}\r\n\t.st2{clip-path:url(#SVGID_5_);fill:#0E2656;}\r\n\t.st3{clip-path:url(#SVGID_7_);fill:#F1F6FF;}\r\n\t.st4{clip-path:url(#SVGID_9_);fill:#DAE7F3;}\r\n\t.st5{clip-path:url(#SVGID_11_);}\r\n\t.st6{fill:#FFFFFF;}\r\n\t.st7{fill:url(#SVGID_12_);}\r\n\t.st8{fill:url(#SVGID_13_);}\r\n\t.st9{fill:url(#SVGID_14_);}\r\n\t.st10{fill:url(#SVGID_15_);}\r\n\t.st11{fill:#E9E9E9;}\r\n\t.st12{fill:url(#SVGID_16_);}\r\n\t.st13{fill:url(#SVGID_17_);}\r\n\t.st14{fill:url(#SVGID_18_);}\r\n\t.st15{fill:#4C8CE4;}\r\n\t.st16{clip-path:url(#SVGID_20_);fill:#FFFFFF;}\r\n\t.st17{clip-path:url(#SVGID_22_);}\r\n\t.st18{fill:url(#SVGID_23_);}\r\n\t.st19{fill:url(#SVGID_24_);}\r\n\t.st20{fill:url(#SVGID_25_);}\r\n\t.st21{fill:url(#SVGID_26_);}\r\n\t.st22{fill:url(#SVGID_27_);}\r\n\t.st23{fill:url(#SVGID_28_);}\r\n\t.st24{fill:url(#SVGID_29_);}\r\n\t.st25{fill:#FE7E66;}\r\n\t.st26{clip-path:url(#SVGID_31_);}\r\n\t.st27{fill:url(#SVGID_32_);}\r\n\t.st28{fill:url(#SVGID_33_);}\r\n\t.st29{fill:url(#SVGID_34_);}\r\n\t.st30{fill:url(#SVGID_35_);}\r\n\t.st31{fill:url(#SVGID_36_);}\r\n\t.st32{fill:url(#SVGID_37_);}\r\n\t.st33{fill:url(#SVGID_38_);}\r\n\t.st34{clip-path:url(#SVGID_40_);}\r\n\t.st35{fill:url(#SVGID_41_);}\r\n\t.st36{fill:url(#SVGID_42_);}\r\n\t.st37{fill:url(#SVGID_43_);}\r\n\t.st38{fill:url(#SVGID_44_);}\r\n\t.st39{fill:url(#SVGID_45_);}\r\n\t.st40{fill:url(#SVGID_46_);}\r\n\t.st41{fill:url(#SVGID_47_);}\r\n\t.st42{fill:#FFC568;}\r\n\t.st43{clip-path:url(#SVGID_49_);}\r\n\t.st44{fill:url(#SVGID_50_);}\r\n\t.st45{fill:url(#SVGID_51_);}\r\n\t.st46{fill:url(#SVGID_52_);}\r\n\t.st47{fill:url(#SVGID_53_);}\r\n\t.st48{fill:url(#SVGID_54_);}\r\n\t.st49{fill:url(#SVGID_55_);}\r\n\t.st50{fill:url(#SVGID_56_);}\r\n\t.st51{fill:#1C3C70;}\r\n\t.st52{clip-path:url(#SVGID_58_);}\r\n\t.st53{fill:url(#SVGID_59_);}\r\n\t.st54{fill:url(#SVGID_60_);}\r\n\t.st55{fill:url(#SVGID_61_);}\r\n\t.st56{fill:url(#SVGID_62_);}\r\n\t.st57{fill:url(#SVGID_63_);}\r\n\t.st58{fill:url(#SVGID_64_);}\r\n\t.st59{fill:url(#SVGID_65_);}\r\n\t.st60{fill:url(#SVGID_66_);}\r\n\t.st61{clip-path:url(#SVGID_68_);}\r\n\t.st62{fill:url(#SVGID_69_);}\r\n\t.st63{fill:url(#SVGID_70_);}\r\n\t.st64{fill:url(#SVGID_71_);}\r\n\t.st65{fill:url(#SVGID_72_);}\r\n\t.st66{fill:url(#SVGID_73_);}\r\n\t.st67{fill:url(#SVGID_74_);}\r\n\t.st68{fill:url(#SVGID_75_);}\r\n\t.st69{clip-path:url(#SVGID_77_);}\r\n\t.st70{fill:url(#SVGID_78_);}\r\n\t.st71{fill:url(#SVGID_79_);}\r\n\t.st72{fill:url(#SVGID_80_);}\r\n\t.st73{fill:url(#SVGID_81_);}\r\n\t.st74{fill:url(#SVGID_82_);}\r\n\t.st75{fill:url(#SVGID_83_);}\r\n\t.st76{fill:url(#SVGID_84_);}\r\n\t.st77{fill:#8994B5;}\r\n\t.st78{clip-path:url(#SVGID_86_);}\r\n\t.st79{fill:url(#SVGID_87_);}\r\n\t.st80{fill:url(#SVGID_88_);}\r\n\t.st81{fill:url(#SVGID_89_);}\r\n\t.st82{fill:url(#SVGID_90_);}\r\n\t.st83{fill:url(#SVGID_91_);}\r\n\t.st84{fill:url(#SVGID_92_);}\r\n\t.st85{fill:url(#SVGID_93_);}\r\n\t.st86{clip-path:url(#SVGID_95_);}\r\n\t.st87{fill:url(#SVGID_96_);}\r\n\t.st88{fill:url(#SVGID_97_);}\r\n\t.st89{fill:url(#SVGID_98_);}\r\n\t.st90{fill:url(#SVGID_99_);}\r\n\t.st91{fill:url(#SVGID_100_);}\r\n\t.st92{fill:url(#SVGID_101_);}\r\n\t.st93{fill:url(#SVGID_102_);}\r\n\t.st94{clip-path:url(#SVGID_104_);}\r\n\t.st95{fill:url(#SVGID_105_);}\r\n\t.st96{fill:url(#SVGID_106_);}\r\n\t.st97{fill:url(#SVGID_107_);}\r\n\t.st98{fill:url(#SVGID_108_);}\r\n\t.st99{fill:url(#SVGID_109_);}\r\n\t.st100{fill:url(#SVGID_110_);}\r\n\t.st101{fill:url(#SVGID_111_);}\r\n\t.st102{fill:url(#SVGID_112_);}\r\n\t.st103{clip-path:url(#SVGID_114_);}\r\n\t.st104{opacity:0.17;fill:#FFFFFF;enable-background:new    ;}\r\n\t.st105{fill:#E4E4E4;}\r\n\t.st106{opacity:0.64;fill:#FFFFFF;enable-background:new    ;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.6,
    y1: 399.7,
    x2: 800,
    y2: 399.7,
    gradientTransform: "matrix(1 0 0 -1 0 800)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#1C3C7F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#082150"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 400.3,
    cy: 400.3,
    r: 399.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_2_",
    cx: 400.3,
    cy: 400.3,
    r: 399.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_3_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_2_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M662.9,70.2c72.1-91.1-90.5,35.6-195.5-13.7c-96.8-45.4-147.4,160.3-223,130.9 c-60.9-23.7-69.5-44.8-104.2-40.4c-44.4,5.6-42.9,74.8-98.6,123c-34.3,29.5-63.9,24.4-96.2,26.3l-68-7.4l72.7,185 c0,0,3.7,18.6,10.1,46.6h222.7C228.1,341.4,626.7,116,662.9,70.2z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_4_",
    cx: 400.3,
    cy: 400.3,
    r: 399.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_5_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_4_",
    style: {
      overflow: "visible"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M723.6,671.9c-58.2-155.1-532,265.4-544.8-116c-0.4-11.6,1-23.5,4.1-35.5H-39.8 C-20,606.8,25.8,782.3,70.3,774.9c10.7-1.7,242.8,46.1,390.9,60.5C550,844.1,741.2,719,723.6,671.9z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_6_",
    cx: 400.3,
    cy: 400.3,
    r: 399.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_7_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_6_",
    style: {
      overflow: "visible"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "151.4,750.7 851.5,343.1 723.8,195.1 -67.5,629.3  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_8_",
    cx: 400.3,
    cy: 400.3,
    r: 399.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_9_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_8_",
    style: {
      overflow: "visible"
    }
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "851.5,354.1 151.4,761.7 151.4,750.6 851.5,343  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_10_",
    cx: 400.3,
    cy: 400.3,
    r: 399.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_11_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_10_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("g", null, _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "597.4,20.3 645,-5.9 783.4,74.2 787.6,76.5 786.9,108.7 732.6,100.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 4055.6494,
    y1: -1249.427,
    x2: 4187.9546,
    y2: -1249.427,
    gradientTransform: "matrix(0.5197 -0.2824 0.2824 -0.834 -1130.4012 135.4835)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "682.2,27.5 635.5,0.1 635.9,-0.6 682.6,26.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 4005.8484,
    y1: -1249.0668,
    x2: 4138.2358,
    y2: -1249.0668,
    gradientTransform: "matrix(0.5197 -0.2824 0.2824 -0.834 -1130.4012 135.4835)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "656.4,41.2 609.7,13.7 610.2,13.1 656.8,40.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 1102.5841,
    y1: 512.2566,
    x2: 1201.9377,
    y2: 512.2566,
    gradientTransform: "matrix(0.8448 -8.174699e-02 0.1031 -0.9449 -365.8874 607.2359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "699.1,51.7 621.2,7.1 621.6,6.3 699.5,51  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 1083.5272,
    y1: 485.8672,
    x2: 1242.5984,
    y2: 485.8672,
    gradientTransform: "matrix(0.8448 -8.174699e-02 0.1031 -0.9449 -365.8874 607.2359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "728.9,89.6 604.2,17.1 604.6,16.5 729.3,88.9  "
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M783.4,74.2c-7,8.4-27.2,20.5-47.3,24.1c11.3,15,12.5,15.6,12.5,15.6l37.6-31v-9.7L783.4,74.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.9229,
    y1: 727.6038,
    x2: 788.9229,
    y2: 727.6038,
    gradientTransform: "matrix(1 0 0 -1 0 800)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C8CE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9943,
    style: {
      stopColor: "#1F6FDD"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M788.9,72.4L788.9,72.4L788.9,72.4L788.9,72.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 788.9229,
    y1: 727.6038,
    x2: 788.9229,
    y2: 727.6038,
    gradientTransform: "matrix(1 0 0 -1 0 800)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C8CE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9943,
    style: {
      stopColor: "#1F6FDD"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M788.9,72.4L788.9,72.4L788.9,72.4L788.9,72.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 729.5756,
    y1: 625.6188,
    x2: 788.2867,
    y2: 626.1575,
    gradientTransform: "matrix(1 0 0 -1 0 800)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C8CE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9943,
    style: {
      stopColor: "#1F6FDD"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M788.9,72.4L788.9,72.4v261c0,3.8-0.1,7.4-1.4,10.8c-3.2,7.8-21.7,19.3-35.9,20.4 c-4.9,0.4-10.6-0.6-12.9-1.7c-1.2-0.6-1.3-3.1-4.2-2.7l-5.4-3V95.9c25.6,12.6,59.8-12.8,54.3-21.6l-138.4-80L640-3.1v-9.8 c0-1.8,1.9-3,3.6-2.1l142.3,82.3C787.8,68.4,788.9,70.2,788.9,72.4L788.9,72.4z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M590.9,276.3l138.4,80.9V95.9c-22.5-11.1-137-80-137-80c-1.5-0.9-3.4,0.2-3.4,1.9v254.9 C588.7,274.1,589.5,275.5,590.9,276.3z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_19_",
    cx: 400.3,
    cy: 400.3,
    r: 399.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "-47.1,650 160.3,764.2 160.3,752.9 -47.1,637.8  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_21_",
    cx: 400.3,
    cy: 400.3,
    r: 399.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st17"
  }, /*#__PURE__*/React.createElement("g", null, _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "527.7,104.8 581.4,74.4 719.7,154.4 723.9,156.7 723.3,188.9 662.8,185.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 3978.0266,
    y1: -1316.1113,
    x2: 4110.3315,
    y2: -1316.1113,
    gradientTransform: "matrix(0.5197 -0.2824 0.2824 -0.834 -1130.4012 135.4835)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st18",
    points: "623,105 576.3,77.6 576.7,76.9 623.4,104.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 3920.3293,
    y1: -1316.9705,
    x2: 4052.7166,
    y2: -1316.9705,
    gradientTransform: "matrix(0.5197 -0.2824 0.2824 -0.834 -1130.4012 135.4835)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st19",
    points: "592.7,122 546,94.6 546.5,93.9 593.1,121.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 1027.9242,
    y1: 427.5899,
    x2: 1127.2777,
    y2: 427.5899,
    gradientTransform: "matrix(0.8448 -8.174699e-02 0.1031 -0.9449 -365.8874 607.2359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "627.3,137.7 549.4,93.1 549.8,92.5 627.7,137  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientUnits: "userSpaceOnUse",
    x1: 1010.9979,
    y1: 402.6939,
    x2: 1170.1917,
    y2: 402.6939,
    gradientTransform: "matrix(0.8448 -8.174699e-02 0.1031 -0.9449 -365.8874 607.2359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st21",
    points: "659.2,174.1 534.4,101.6 534.8,101 659.6,173.4  "
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M719.7,154.4c-7,8.4-33.3,24.7-53.4,28.4c11.3,15,12.5,15.6,12.5,15.6l43.8-35.2v-9.7L719.7,154.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 725.3319,
    y1: 647.3971,
    x2: 725.3319,
    y2: 647.3971,
    gradientTransform: "matrix(1 0 0 -1 0 800)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C8CE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9943,
    style: {
      stopColor: "#1F6FDD"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M725.3,152.6L725.3,152.6L725.3,152.6L725.3,152.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 725.3319,
    y1: 647.3971,
    x2: 725.3319,
    y2: 647.3971,
    gradientTransform: "matrix(1 0 0 -1 0 800)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C8CE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9943,
    style: {
      stopColor: "#1F6FDD"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M725.3,152.6L725.3,152.6L725.3,152.6L725.3,152.6z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 660.3021,
    y1: 566.9445,
    x2: 723.676,
    y2: 566.9445,
    gradientTransform: "matrix(1 0 0 -1 0 800)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000476372,
    style: {
      stopColor: "#8994B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9948,
    style: {
      stopColor: "#5E6E9A"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M725.3,152.7L725.3,152.7v212.6c0,3.8-0.5,7.2-1.2,9.1c-5.1,13.4-29,26.8-47,26.8c-3.3,0-5.7-1-8-2.3 c-1.2-0.6-1.3-3.1-4.2-2.7l-5.4-3V180.4c25.6,12.6,65.9-17,60.4-25.9l-138.4-80l-4.9,2.7v-9.8c0-1.8,1.9-3,3.6-2.1l142.3,82.3 C724.1,148.6,725.3,150.4,725.3,152.7C725.3,152.6,725.3,152.6,725.3,152.7z"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M521,312.3l138.4,80.9V180.4c-22.5-11.1-137-80-137-80c-1.5-0.9-3.4,0.2-3.4,1.9v206.4 C519,310.2,519.7,311.6,521,312.3z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_30_",
    cx: 400.3,
    cy: 400.3,
    r: 399.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_31_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_30_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st26"
  }, /*#__PURE__*/React.createElement("g", null, _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "467.6,118.3 514.8,91.6 653.5,172.2 657.6,174.4 657,206.7 602.7,198.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 3827.6709,
    y1: -1289.7526,
    x2: 3960.0581,
    y2: -1289.7526,
    gradientTransform: "matrix(0.5197 -0.2824 0.2824 -0.834 -1130.4012 135.4835)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st27",
    points: "552.3,125.5 505.6,98 506,97.3 552.7,124.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientUnits: "userSpaceOnUse",
    x1: 3777.8699,
    y1: -1289.3513,
    x2: 3910.2483,
    y2: -1289.3513,
    gradientTransform: "matrix(0.5197 -0.2824 0.2824 -0.834 -1130.4012 135.4835)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "526.6,139.3 479.8,111.8 480.2,111.1 527,138.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientUnits: "userSpaceOnUse",
    x1: 959.9173,
    y1: 420.823,
    x2: 1059.2709,
    y2: 420.823,
    gradientTransform: "matrix(0.8448 -8.174699e-02 0.1031 -0.9449 -365.8874 607.2359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st29",
    points: "569.2,149.7 491.3,105.1 491.7,104.4 569.5,149  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientUnits: "userSpaceOnUse",
    x1: 940.9832,
    y1: 394.4832,
    x2: 1100.0543,
    y2: 394.4832,
    gradientTransform: "matrix(0.8448 -8.174699e-02 0.1031 -0.9449 -365.8874 607.2359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st30",
    points: "599.1,187.7 474.4,115.2 474.8,114.4 599.5,187  "
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M653.5,172.2c-7,8.4-27.2,20.5-47.3,24.1c11.3,15,12.5,15.6,12.5,15.6l37.6-31v-9.6L653.5,172.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientUnits: "userSpaceOnUse",
    x1: 657.4013,
    y1: 629.615,
    x2: 660.7466,
    y2: 629.6457,
    gradientTransform: "matrix(1 0 0 -1 0 800)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C8CE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9943,
    style: {
      stopColor: "#1F6FDD"
    }
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M659.1,170.3C659.1,170.3,659.1,170.4,659.1,170.3L659.1,170.3C659.1,170.4,659.1,170.3,659.1,170.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientUnits: "userSpaceOnUse",
    x1: 657.4013,
    y1: 629.615,
    x2: 660.7466,
    y2: 629.6457,
    gradientTransform: "matrix(1 0 0 -1 0 800)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C8CE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9943,
    style: {
      stopColor: "#1F6FDD"
    }
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M659.1,170.3C659.1,170.3,659.1,170.4,659.1,170.3L659.1,170.3C659.1,170.4,659.1,170.3,659.1,170.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientUnits: "userSpaceOnUse",
    x1: 599.3336,
    y1: 540.0229,
    x2: 658.2946,
    y2: 540.5638,
    gradientTransform: "matrix(1 0 0 -1 0 800)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#FE7E66"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9939,
    style: {
      stopColor: "#F9674B"
    }
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M659.1,170.4L659.1,170.4v236c0,3.8-0.1,7.4-1.4,10.8c-3.2,7.8-21.7,19.3-35.9,20.4 c-4.9,0.4-10.6-0.6-12.9-1.7c-1.2-0.6-1.3-3.1-4.2-2.7l-5.4-3V193.9c25.6,12.6,59.8-12.8,54.3-21.6L514.8,91.6l-5,3l0.6-9.3 c0-1.8,1.9-3,3.6-2.1l142.3,82.3C657.9,166.4,659.1,168.2,659.1,170.4C659.1,170.3,659.1,170.4,659.1,170.4z"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M460.9,349.2l138.4,80.9V193.8c-22.5-11.1-137-80-137-80c-1.5-0.9-3.4,0.2-3.4,1.9v229.9 C458.9,347.2,459.7,348.5,460.9,349.2z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_39_",
    cx: 400.3,
    cy: 400.3,
    r: 399.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_40_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_39_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st34"
  }, /*#__PURE__*/React.createElement("g", null, _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "412.2,168.2 447.7,148.2 586,228.2 590.3,230.5 589.6,262.7 547.3,248.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientUnits: "userSpaceOnUse",
    x1: 3721.751,
    y1: -1317.7635,
    x2: 3854.0562,
    y2: -1317.7635,
    gradientTransform: "matrix(0.5197 -0.2824 0.2824 -0.834 -1130.4012 135.4835)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st35",
    points: "489.3,178.8 442.7,151.4 443.1,150.7 489.7,178  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientUnits: "userSpaceOnUse",
    x1: 3698.6968,
    y1: -1317.9027,
    x2: 3831.084,
    y2: -1317.9027,
    gradientTransform: "matrix(0.5197 -0.2824 0.2824 -0.834 -1130.4012 135.4835)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st36",
    points: "477.3,185.4 430.7,157.9 431.1,157.2 477.7,184.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientUnits: "userSpaceOnUse",
    x1: 898.1559,
    y1: 371.7894,
    x2: 997.5096,
    y2: 371.7894,
    gradientTransform: "matrix(0.8448 -8.174699e-02 0.1031 -0.9449 -365.8874 607.2359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "st37",
    points: "511.9,201.1 434,156.5 434.5,155.8 512.3,200.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientUnits: "userSpaceOnUse",
    x1: 881.2297,
    y1: 346.8988,
    x2: 1040.3008,
    y2: 346.8988,
    gradientTransform: "matrix(0.8448 -8.174699e-02 0.1031 -0.9449 -365.8874 607.2359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st38",
    points: "543.7,237.5 419,165 419.4,164.3 544.1,236.8  "
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M586,228.2c-7,8.4-15.1,14.4-35.3,18.1c11.3,15,12.5,15.6,12.5,15.6l25.5-24.8v-9.7L586,228.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientUnits: "userSpaceOnUse",
    x1: 591.6883,
    y1: 573.652,
    x2: 591.6883,
    y2: 573.652,
    gradientTransform: "matrix(1 0 0 -1 0 800)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C8CE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9943,
    style: {
      stopColor: "#1F6FDD"
    }
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M591.7,226.3L591.7,226.3L591.7,226.3L591.7,226.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientUnits: "userSpaceOnUse",
    x1: 591.6883,
    y1: 573.652,
    x2: 591.6883,
    y2: 573.652,
    gradientTransform: "matrix(1 0 0 -1 0 800)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C8CE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9943,
    style: {
      stopColor: "#1F6FDD"
    }
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M591.7,226.3L591.7,226.3L591.7,226.3L591.7,226.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 545.7544,
    y1: 499.8835,
    x2: 590.1932,
    y2: 501.4995,
    gradientTransform: "matrix(1 0 0 -1 0 800)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#FFC568"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFAB48"
    }
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M591.7,226.3L591.7,226.3V439c0,3.8-0.7,7.2-1.2,9.1c-2.4,8.5-18.8,17.5-28.8,16.4c-3.2-0.4-5.7-1-8-2.3 c-1.2-0.6-1.3-3.1-4.2-2.7l-5.4-3V243.8c25.6,12.6,47.7-6.7,42.2-15.6l-138.4-80l-4.9,2.7V141c0-1.8,1.9-3,3.6-2.1l142.3,82.3 C590.5,222.3,591.7,224.2,591.7,226.3L591.7,226.3z"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M405.5,375.7l138.4,80.9V243.8c-22.5-11.1-137-80-137-80c-1.5-0.9-3.4,0.2-3.4,1.9v206.4 C403.5,373.5,404.3,375,405.5,375.7z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_48_",
    cx: 400.3,
    cy: 400.3,
    r: 399.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_49_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_48_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st43"
  }, /*#__PURE__*/React.createElement("g", null, _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "354.4,152.1 401.8,126 540.2,206 544.4,208.3 543.8,240.5 489.4,232.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 3587.5002,
    y1: -1248.9932,
    x2: 3719.8875,
    y2: -1248.9932,
    gradientTransform: "matrix(0.5197 -0.2824 0.2824 -0.834 -1130.4012 135.4835)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st44",
    points: "439,159.4 392.3,131.9 392.7,131.2 439.4,158.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 3537.7,
    y1: -1248.5575,
    x2: 3670.0869,
    y2: -1248.5575,
    gradientTransform: "matrix(0.5197 -0.2824 0.2824 -0.834 -1130.4012 135.4835)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "st45",
    points: "413.2,173 366.6,145.6 367,144.9 413.6,172.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 828.87,
    y1: 396.4,
    x2: 928.2236,
    y2: 396.4,
    gradientTransform: "matrix(0.8448 -8.174699e-02 0.1031 -0.9449 -365.8874 607.2359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "st46",
    points: "455.9,183.5 378,139 378.5,138.2 456.3,182.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 809.8132,
    y1: 370.0107,
    x2: 968.8843,
    y2: 370.0107,
    gradientTransform: "matrix(0.8448 -8.174699e-02 0.1031 -0.9449 -365.8874 607.2359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "st47",
    points: "485.7,221.5 361,149 361.4,148.3 486.1,220.8  "
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M540.2,206c-7,8.4-27.2,20.5-47.3,24.1c11.3,15,12.5,15.6,12.5,15.6l37.6-31v-9.6L540.2,206z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 485.4659,
    y1: 595.2527,
    x2: 544.179,
    y2: 595.7914,
    gradientTransform: "matrix(1 0 0 -1 0 800)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C8CE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9943,
    style: {
      stopColor: "#1F6FDD"
    }
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M545.8,204.2L545.8,204.2L545.8,204.2C545.7,204.2,545.7,204.2,545.8,204.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 485.4659,
    y1: 595.2527,
    x2: 544.179,
    y2: 595.7914,
    gradientTransform: "matrix(1 0 0 -1 0 800)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C8CE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9943,
    style: {
      stopColor: "#1F6FDD"
    }
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st49",
    d: "M545.8,204.2L545.8,204.2L545.8,204.2C545.7,204.2,545.7,204.2,545.8,204.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 490.671,
    y1: 493.5123,
    x2: 542.5392,
    y2: 493.5123,
    gradientTransform: "matrix(1 0 0 -1 0 800)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#1C3C70"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#082150"
    }
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M545.7,204.2L545.7,204.2v261c0,3.8-0.1,7.4-1.4,10.8c-3.2,7.8-21.7,19.3-35.9,20.4 c-4.9,0.4-10.6-0.6-12.9-1.7c-1.2-0.6-1.3-3.1-4.2-2.7l-5.4-3V227.7c25.6,12.6,59.8-12.8,54.3-21.6l-138.4-80l-4.9,2.7v-9.8 c0-1.8,1.9-3,3.6-2.1l142.3,82.3C544.6,200.2,545.7,202,545.7,204.2L545.7,204.2z"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M347.7,408.1L486,489V227.7c-22.5-11.1-137-80-137-80c-1.5-0.9-3.4,0.2-3.4,1.9v254.9 C345.6,406,346.4,407.4,347.7,408.1z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_57_",
    cx: 400.3,
    cy: 400.3,
    r: 399.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_58_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_57_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st52"
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M435.9,283.1"
  })), /*#__PURE__*/React.createElement("g", null, _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "304.2,207.4 333.9,190.3 472.3,270.3 476.5,272.6 466.8,311.4 439.3,287.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_59_",
    gradientUnits: "userSpaceOnUse",
    x1: 328.2986,
    y1: 567.6519,
    x2: 460.6089,
    y2: 567.6519,
    gradientTransform: "matrix(1 0 0 -1 0 800)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "st53",
    points: "460.2,271.5 328.3,193.9 328.7,193.2 460.6,270.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_60_",
    gradientUnits: "userSpaceOnUse",
    x1: 3474.1956,
    y1: -1289.1996,
    x2: 3606.5828,
    y2: -1289.1996,
    gradientTransform: "matrix(0.5197 -0.2824 0.2824 -0.834 -1130.4012 135.4835)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "st54",
    points: "368.7,224.9 322,197.4 322.5,196.7 369.1,224.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_61_",
    gradientUnits: "userSpaceOnUse",
    x1: 3463.5383,
    y1: -1289.6688,
    x2: 3595.9255,
    y2: -1289.6688,
    gradientTransform: "matrix(0.5197 -0.2824 0.2824 -0.834 -1130.4012 135.4835)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "st55",
    points: "363.1,228.3 316.4,200.8 316.8,200.1 363.5,227.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_62_",
    gradientUnits: "userSpaceOnUse",
    x1: 776.0707,
    y1: 342.5147,
    x2: 875.4243,
    y2: 342.5147,
    gradientTransform: "matrix(0.8448 -8.174699e-02 0.1031 -0.9449 -365.8874 607.2359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "st56",
    points: "405.7,238.8 327.9,194.1 328.3,193.4 406.1,238  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_63_",
    gradientUnits: "userSpaceOnUse",
    x1: 757.0138,
    y1: 316.1802,
    x2: 916.085,
    y2: 316.1802,
    gradientTransform: "matrix(0.8448 -8.174699e-02 0.1031 -0.9449 -365.8874 607.2359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "st57",
    points: "435.6,276.7 310.9,204.2 311.3,203.5 436,276  "
  }))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M472.3,270.3c-4.2,4.9-12,12-31.1,15.9c23.6,5.6,16,20.3,16,20.3l19.2-25.6L472.3,270.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_64_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.9425,
    y1: 531.4974,
    x2: 477.9425,
    y2: 531.4974,
    gradientTransform: "matrix(1 0 0 -1 0 800)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#FFC568"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFB248"
    }
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M477.9,268.5L477.9,268.5L477.9,268.5L477.9,268.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_65_",
    gradientUnits: "userSpaceOnUse",
    x1: 477.9425,
    y1: 531.4974,
    x2: 477.9425,
    y2: 531.4974,
    gradientTransform: "matrix(1 0 0 -1 0 800)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#FFC568"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFB248"
    }
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M477.9,268.5L477.9,268.5L477.9,268.5L477.9,268.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_66_",
    gradientUnits: "userSpaceOnUse",
    x1: 438.9602,
    y1: 445.8328,
    x2: 476.9697,
    y2: 445.8328,
    gradientTransform: "matrix(1 0 0 -1 0 800)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C8CE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9943,
    style: {
      stopColor: "#1F6FDD"
    }
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st60",
    d: "M477.9,268.5L477.9,268.5v236.8c0,3.8-0.7,7.2-1.2,9.1c-1.1,4.2-11.6,12.3-19.4,12.9 c-4.9,0.3-9.5-0.5-11.8-1.7c-1.2-0.6-1.3-3.1-4.2-2.7l-5.4-3V283c19.4,9,42.1-3.8,36.5-12.6l-138.4-80l-4.9,3.3v-10.4 c0-1.8,1.9-3,3.6-2.1l142.2,82.3C476.7,264.5,477.9,266.3,477.9,268.5L477.9,268.5z"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M297.5,439.1L435.9,520V282.9c-22.5-11.1-137-80-137-80c-1.5-0.9-3.4,0.2-3.4,1.9v230.7 C295.5,437,296.2,438.4,297.5,439.1z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_67_",
    cx: 400.3,
    cy: 400.3,
    r: 399.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_68_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_67_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st61"
  }, /*#__PURE__*/React.createElement("g", null, _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "233.3,268.8 287.1,238.5 425.4,318.6 429.5,320.8 428.9,353 368.4,349.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_69_",
    gradientUnits: "userSpaceOnUse",
    x1: 3414.9648,
    y1: -1322.1353,
    x2: 3547.3521,
    y2: -1322.1353,
    gradientTransform: "matrix(0.5197 -0.2824 0.2824 -0.834 -1130.4012 135.4835)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "st62",
    points: "328.6,269.1 281.9,241.6 282.3,240.9 329,268.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_70_",
    gradientUnits: "userSpaceOnUse",
    x1: 3357.2681,
    y1: -1323.0007,
    x2: 3489.5732,
    y2: -1323.0007,
    gradientTransform: "matrix(0.5197 -0.2824 0.2824 -0.834 -1130.4012 135.4835)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "st63",
    points: "298.5,286 251.8,258.7 252.2,257.9 298.9,285.3  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_71_",
    gradientUnits: "userSpaceOnUse",
    x1: 697.3073,
    y1: 282.5725,
    x2: 796.6609,
    y2: 282.5725,
    gradientTransform: "matrix(0.8448 -8.174699e-02 0.1031 -0.9449 -365.8874 607.2359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "st64",
    points: "333,301.8 255.2,257.2 255.6,256.5 333.4,301.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_72_",
    gradientUnits: "userSpaceOnUse",
    x1: 680.381,
    y1: 257.6819,
    x2: 839.4521,
    y2: 257.6819,
    gradientTransform: "matrix(0.8448 -8.174699e-02 0.1031 -0.9449 -365.8874 607.2359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "st65",
    points: "364.8,338.2 240.1,265.7 240.5,265 365.2,337.5  "
  }))), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M425.4,318.6c-7,8.4-33.3,24.7-53.4,28.4c11.3,15,12.5,15.6,12.5,15.6l43.8-35.2v-9.7L425.4,318.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_73_",
    gradientUnits: "userSpaceOnUse",
    x1: 430.9673,
    y1: 483.2914,
    x2: 430.9673,
    y2: 483.2914,
    gradientTransform: "matrix(1 0 0 -1 0 800)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C8CE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9943,
    style: {
      stopColor: "#1F6FDD"
    }
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st66",
    d: "M431,316.7L431,316.7L431,316.7L431,316.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_74_",
    gradientUnits: "userSpaceOnUse",
    x1: 430.9673,
    y1: 483.2914,
    x2: 430.9673,
    y2: 483.2914,
    gradientTransform: "matrix(1 0 0 -1 0 800)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C8CE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9943,
    style: {
      stopColor: "#1F6FDD"
    }
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st67",
    d: "M431,316.7L431,316.7L431,316.7L431,316.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_75_",
    gradientUnits: "userSpaceOnUse",
    x1: 365.9729,
    y1: 402.9413,
    x2: 429.347,
    y2: 402.9413,
    gradientTransform: "matrix(1 0 0 -1 0 800)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#FE7E66"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9939,
    style: {
      stopColor: "#F9674B"
    }
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st68",
    d: "M431,316.7L431,316.7v212.6c0,3.8-0.5,7.2-1.2,9.1c-5.1,13.4-29,26.8-47,26.8c-3.3,0-5.7-1-8-2.3 c-1.2-0.6-1.3-3.1-4.2-2.7l-5.4-3V344.4c25.6,12.6,66-17,60.4-25.9l-138.4-80l-4.9,2.7v-9.8c0-1.8,1.9-3,3.6-2.1l142.3,82.3 C429.8,312.7,431,314.6,431,316.7L431,316.7z"
  }))), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M226.7,476.3L365,557.2V344.4c-22.5-11.1-137-80-137-80c-1.5-0.9-3.4,0.2-3.4,1.9v206.5 C224.6,474.3,225.4,475.6,226.7,476.3z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_76_",
    cx: 400.3,
    cy: 400.3,
    r: 399.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_77_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_76_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st69"
  }, /*#__PURE__*/React.createElement("g", null, _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "173.3,282.3 220.4,255.6 359.2,336.3 363.4,338.6 362.8,370.8 308.4,363  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_78_",
    gradientUnits: "userSpaceOnUse",
    x1: 3264.6089,
    y1: -1295.7764,
    x2: 3396.9141,
    y2: -1295.7764,
    gradientTransform: "matrix(0.5197 -0.2824 0.2824 -0.834 -1130.4012 135.4835)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "st70",
    points: "257.9,289.5 211.3,262.1 211.7,261.4 258.3,288.8  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_79_",
    gradientUnits: "userSpaceOnUse",
    x1: 3214.8081,
    y1: -1295.416,
    x2: 3347.1953,
    y2: -1295.416,
    gradientTransform: "matrix(0.5197 -0.2824 0.2824 -0.834 -1130.4012 135.4835)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "st71",
    points: "232.2,303.3 185.5,275.8 185.9,275.2 232.6,302.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_80_",
    gradientUnits: "userSpaceOnUse",
    x1: 629.287,
    y1: 275.8657,
    x2: 728.6406,
    y2: 275.8657,
    gradientTransform: "matrix(0.8448 -8.174699e-02 0.1031 -0.9449 -365.8874 607.2359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "st72",
    points: "274.9,313.7 197,269.1 197.4,268.4 275.3,313  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_81_",
    gradientUnits: "userSpaceOnUse",
    x1: 610.2302,
    y1: 249.4763,
    x2: 769.3013,
    y2: 249.4763,
    gradientTransform: "matrix(0.8448 -8.174699e-02 0.1031 -0.9449 -365.8874 607.2359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "st73",
    points: "304.7,351.7 180,279.2 180.4,278.6 305.1,351  "
  }))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M359.2,336.3c-7,8.4-27.2,20.5-47.3,24.1c11.3,15,12.5,15.6,12.5,15.6l37.6-31v-9.7L359.2,336.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_82_",
    gradientUnits: "userSpaceOnUse",
    x1: 364.8122,
    y1: 465.5474,
    x2: 364.8122,
    y2: 465.5474,
    gradientTransform: "matrix(1 0 0 -1 0 800)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C8CE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9943,
    style: {
      stopColor: "#1F6FDD"
    }
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st74",
    d: "M364.8,334.5L364.8,334.5L364.8,334.5L364.8,334.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_83_",
    gradientUnits: "userSpaceOnUse",
    x1: 364.8122,
    y1: 465.5474,
    x2: 364.8122,
    y2: 465.5474,
    gradientTransform: "matrix(1 0 0 -1 0 800)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C8CE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9943,
    style: {
      stopColor: "#1F6FDD"
    }
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st75",
    d: "M364.8,334.5L364.8,334.5L364.8,334.5L364.8,334.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_84_",
    gradientUnits: "userSpaceOnUse",
    x1: 305.0041,
    y1: 376.0205,
    x2: 363.9651,
    y2: 376.5614,
    gradientTransform: "matrix(1 0 0 -1 0 800)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000476372,
    style: {
      stopColor: "#8994B5"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9948,
    style: {
      stopColor: "#5E6E9A"
    }
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "st76",
    d: "M364.7,334.5L364.7,334.5v236c0,3.8-0.1,7.4-1.4,10.8c-3.2,7.8-21.7,19.3-35.9,20.4 c-4.9,0.4-10.6-0.6-12.9-1.7c-1.2-0.6-1.3-3.1-4.2-2.7l-5.4-3V357.9c25.6,12.6,59.8-12.8,54.3-21.6l-138.8-80.7l-5,3l0.6-9.3 c0-1.8,1.9-3,3.6-2.1l142.3,82.3C363.6,330.5,364.8,332.3,364.7,334.5C364.8,334.5,364.8,334.5,364.7,334.5z"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st77",
    d: "M166.7,513.3L305,594.3V357.9c-22.5-11.1-137-80-137-80c-1.5-0.9-3.4,0.2-3.4,1.9v229.9 C164.6,511.2,165.3,512.5,166.7,513.3z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_85_",
    cx: 400.3,
    cy: 400.3,
    r: 399.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_86_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_85_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st78"
  }, /*#__PURE__*/React.createElement("g", null, _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "124.5,332.9 160.1,312.9 298.3,393 302.6,395.3 301.9,427.5 259.7,413.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_87_",
    gradientUnits: "userSpaceOnUse",
    x1: 3174.928,
    y1: -1330.1655,
    x2: 3307.3152,
    y2: -1330.1655,
    gradientTransform: "matrix(0.5197 -0.2824 0.2824 -0.834 -1130.4012 135.4835)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    className: "st79",
    points: "201.6,343.6 155,316.1 155.4,315.4 202,342.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_88_",
    gradientUnits: "userSpaceOnUse",
    x1: 3151.874,
    y1: -1330.3047,
    x2: 3284.1792,
    y2: -1330.3047,
    gradientTransform: "matrix(0.5197 -0.2824 0.2824 -0.834 -1130.4012 135.4835)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    className: "st80",
    points: "189.6,350.1 143,322.8 143.4,322 190,349.4  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_89_",
    gradientUnits: "userSpaceOnUse",
    x1: 575.4859,
    y1: 225.2698,
    x2: 674.8395,
    y2: 225.2698,
    gradientTransform: "matrix(0.8448 -8.174699e-02 0.1031 -0.9449 -365.8874 607.2359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    className: "st81",
    points: "224.2,365.9 146.3,321.3 146.8,320.6 224.6,365.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_90_",
    gradientUnits: "userSpaceOnUse",
    x1: 558.5596,
    y1: 200.434,
    x2: 717.6307,
    y2: 200.434,
    gradientTransform: "matrix(0.8448 -8.174699e-02 0.1031 -0.9449 -365.8874 607.2359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    className: "st82",
    points: "256,402.2 131.3,329.8 131.7,329.1 256.4,401.6  "
  }))), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M298.3,393c-7,8.4-15.1,14.4-35.3,18.1c11.3,15,12.5,15.6,12.5,15.6l25.5-24.8v-9.7L298.3,393z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_91_",
    gradientUnits: "userSpaceOnUse",
    x1: 303.9904,
    y1: 408.8284,
    x2: 303.9904,
    y2: 408.8284,
    gradientTransform: "matrix(1 0 0 -1 0 800)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C8CE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9943,
    style: {
      stopColor: "#1F6FDD"
    }
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st83",
    d: "M304,391.2L304,391.2L304,391.2L304,391.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_92_",
    gradientUnits: "userSpaceOnUse",
    x1: 303.9904,
    y1: 408.8284,
    x2: 303.9904,
    y2: 408.8284,
    gradientTransform: "matrix(1 0 0 -1 0 800)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C8CE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9943,
    style: {
      stopColor: "#1F6FDD"
    }
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st84",
    d: "M304,391.2L304,391.2L304,391.2L304,391.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_93_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.761,
    y1: 333.61,
    x2: 296.15,
    y2: 333.61,
    gradientTransform: "matrix(1 0 0 -1 0 800)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#1C3C70"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#082150"
    }
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st85",
    d: "M304,391.2L304,391.2v212.6c0,3.8-0.7,7.2-1.2,9.1c-2.4,8.5-18.8,17.5-28.8,16.4c-3.2-0.4-5.7-1-8-2.3 c-1.2-0.6-1.3-3.1-4.2-2.7l-5.4-3V408.5c25.6,12.6,47.7-6.7,42.2-15.6l-138.4-80l-4.9,2.7v-9.8c0-1.8,1.9-3,3.6-2.1L301,385.9 C302.8,387.2,304,389,304,391.2L304,391.2z"
  }))), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M117.8,540.4l138.4,80.9V408.5c-22.5-11.1-137-80-137-80c-1.5-0.9-3.4,0.2-3.4,1.9v206.4 C115.8,538.4,116.6,539.7,117.8,540.4z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_94_",
    cx: 400.3,
    cy: 400.3,
    r: 399.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_95_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_94_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st86"
  }, /*#__PURE__*/React.createElement("g", null, _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "64,323.3 111.5,297.1 249.8,377.2 254,379.5 253.3,411.7 199.1,403.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_96_",
    gradientUnits: "userSpaceOnUse",
    x1: 3039.4438,
    y1: -1268.61,
    x2: 3171.749,
    y2: -1268.61,
    gradientTransform: "matrix(0.5197 -0.2824 0.2824 -0.834 -1130.4012 135.4835)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    className: "st87",
    points: "148.6,330.5 101.9,303.1 102.3,302.3 149,329.7  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_97_",
    gradientUnits: "userSpaceOnUse",
    x1: 2989.644,
    y1: -1268.2498,
    x2: 3122.031,
    y2: -1268.2498,
    gradientTransform: "matrix(0.5197 -0.2824 0.2824 -0.834 -1130.4012 135.4835)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    className: "st88",
    points: "122.9,344.2 76.2,316.7 76.6,316.1 123.3,343.5  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_98_",
    gradientUnits: "userSpaceOnUse",
    x1: 503.8263,
    y1: 243.4095,
    x2: 603.1799,
    y2: 243.4095,
    gradientTransform: "matrix(0.8448 -8.174699e-02 0.1031 -0.9449 -365.8874 607.2359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    className: "st89",
    points: "165.5,354.7 87.7,310 88.1,309.3 165.9,353.9  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_99_",
    gradientUnits: "userSpaceOnUse",
    x1: 484.7695,
    y1: 217.0202,
    x2: 643.8406,
    y2: 217.0202,
    gradientTransform: "matrix(0.8448 -8.174699e-02 0.1031 -0.9449 -365.8874 607.2359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    className: "st90",
    points: "195.4,392.6 70.7,320.1 71.1,319.5 195.8,391.9  "
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M249.8,377.2c-7,8.4-27.2,20.5-47.3,24.1c11.3,15,12.5,15.6,12.5,15.6l37.6-31v-9.7L249.8,377.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_100_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.3741,
    y1: 424.6236,
    x2: 255.3741,
    y2: 424.6236,
    gradientTransform: "matrix(1 0 0 -1 0 800)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C8CE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9943,
    style: {
      stopColor: "#1F6FDD"
    }
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st91",
    d: "M255.4,375.4L255.4,375.4L255.4,375.4L255.4,375.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_101_",
    gradientUnits: "userSpaceOnUse",
    x1: 255.3741,
    y1: 424.6236,
    x2: 255.3741,
    y2: 424.6236,
    gradientTransform: "matrix(1 0 0 -1 0 800)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C8CE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9943,
    style: {
      stopColor: "#1F6FDD"
    }
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st92",
    d: "M255.4,375.4L255.4,375.4L255.4,375.4L255.4,375.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_102_",
    gradientUnits: "userSpaceOnUse",
    x1: 196.0288,
    y1: 322.6386,
    x2: 254.7399,
    y2: 323.1773,
    gradientTransform: "matrix(1 0 0 -1 0 800)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#4C8CE4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9943,
    style: {
      stopColor: "#1F6FDD"
    }
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "st93",
    d: "M255.4,375.4L255.4,375.4v261c0,3.8-0.1,7.4-1.4,10.8c-3.2,7.8-21.7,19.3-35.9,20.4 c-4.9,0.4-10.6-0.6-12.9-1.7c-1.2-0.6-1.3-3.1-4.2-2.7l-5.4-3V398.9c25.6,12.6,59.8-12.8,54.3-21.6l-138.4-80l-4.9,2.7V290 c0-1.8,1.9-3,3.6-2.1l142.4,82.3C254.2,371.4,255.4,373.2,255.4,375.4L255.4,375.4z"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M57.3,579.3l138.4,80.9V398.9c-22.5-11.1-137-80-137-80c-1.5-0.9-3.4,0.2-3.4,1.9v254.9 C55.2,577.1,56,578.6,57.3,579.3z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_103_",
    cx: 400.3,
    cy: 400.3,
    r: 399.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_104_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_103_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st94"
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M124.1,464.2"
  })), /*#__PURE__*/React.createElement("g", null, _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "-7.6,388.4 49,355.8 187.4,435.8 191.5,438 181.8,476.8 127.5,469  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_105_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.2675,
    y1: 402.2129,
    x2: 175.6803,
    y2: 402.2129,
    gradientTransform: "matrix(1 0 0 -1 0 800)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    className: "st95",
    points: "175.3,436.9 43.3,359.3 43.7,358.7 175.7,436.2  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_106_",
    gradientUnits: "userSpaceOnUse",
    x1: 2934.3862,
    y1: -1304.7515,
    x2: 3066.7651,
    y2: -1304.7515,
    gradientTransform: "matrix(0.5197 -0.2824 0.2824 -0.834 -1130.4012 135.4835)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    className: "st96",
    points: "83.8,390.4 37,362.9 37.4,362.1 84.2,389.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_107_",
    gradientUnits: "userSpaceOnUse",
    x1: 2872.9387,
    y1: -1306.7886,
    x2: 3005.2439,
    y2: -1306.7886,
    gradientTransform: "matrix(0.5197 -0.2824 0.2824 -0.834 -1130.4012 135.4835)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    className: "st97",
    points: "51.3,409.3 4.6,381.9 5,381.2 51.7,408.6  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_108_",
    gradientUnits: "userSpaceOnUse",
    x1: 426.6805,
    y1: 181.1015,
    x2: 526.0341,
    y2: 181.1015,
    gradientTransform: "matrix(0.8448 -8.174699e-02 0.1031 -0.9449 -365.8874 607.2359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon59 || (_polygon59 = /*#__PURE__*/React.createElement("polygon", {
    className: "st98",
    points: "93.9,419.8 16.1,375.2 16.5,374.6 94.3,419.1  "
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_109_",
    gradientUnits: "userSpaceOnUse",
    x1: 407.637,
    y1: 154.7617,
    x2: 566.8309,
    y2: 154.7617,
    gradientTransform: "matrix(0.8448 -8.174699e-02 0.1031 -0.9449 -365.8874 607.2359)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#EFEFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFFFFF"
    }
  })), _polygon60 || (_polygon60 = /*#__PURE__*/React.createElement("polygon", {
    className: "st99",
    points: "123.9,457.7 -0.9,385.3 -0.5,384.6 124.3,457.1  "
  }))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M187.4,435.8c-10.6,12.6-24.1,24.8-57.8,31.5c23.6,5.6,42.9,4.6,42.9,4.6l19.2-25.6L187.4,435.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_110_",
    gradientUnits: "userSpaceOnUse",
    x1: 192.9114,
    y1: 366.0583,
    x2: 192.9114,
    y2: 366.0583,
    gradientTransform: "matrix(1 0 0 -1 0 800)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#FFC568"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFB248"
    }
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st100",
    d: "M192.9,433.9L192.9,433.9L192.9,433.9L192.9,433.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_111_",
    gradientUnits: "userSpaceOnUse",
    x1: 192.9114,
    y1: 366.0583,
    x2: 192.9114,
    y2: 366.0583,
    gradientTransform: "matrix(1 0 0 -1 0 800)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#FFC568"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFB248"
    }
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st101",
    d: "M192.9,433.9L192.9,433.9L192.9,433.9L192.9,433.9z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_112_",
    gradientUnits: "userSpaceOnUse",
    x1: 127.4411,
    y1: 273.2115,
    x2: 191.0021,
    y2: 274.2889,
    gradientTransform: "matrix(1 0 0 -1 0 800)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0004573171,
    style: {
      stopColor: "#FFC568"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9944,
    style: {
      stopColor: "#FFAB48"
    }
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st102",
    d: "M192.9,433.9L192.9,433.9v236.8c0,3.8-0.6,7.2-1.2,9.1c-5.1,17.7-25.7,28.5-46.2,28.5 c-5,0-9.5-0.5-11.8-1.7c-1.2-0.6-1.3-3.1-4.2-2.7l-5.4-3V464c25.6,12.6,69.4-14.9,63.3-28.2L49,355.8l-4.9,3.2v-10.4 c0-1.8,1.9-3,3.6-2.1l142.3,82.3C191.8,429.9,192.9,431.8,192.9,433.9L192.9,433.9z"
  }))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M-14.3,620.2l138.4,80.9V464c-22.5-11.1-137-80-137-80c-1.5-0.9-3.4,0.2-3.4,1.9v230.7 C-16.3,618-15.5,619.4-14.3,620.2z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_113_",
    cx: 400.3,
    cy: 400.3,
    r: 399.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_114_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_113_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st103"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st104",
    points: "571.9,532.7 419.7,620 419.7,816.7 571.9,729.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M418.9,818.1V619.5l153.7-88.2v198.6l-0.4,0.2L418.9,818.1z M420.5,620.4v194.9l150.6-86.4V534 L420.5,620.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st106",
    points: "508,607.1 444.2,643.7 444.2,651.7 508,615.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st106",
    points: "534.1,630.4 444.2,681.6 444.2,689.6 534.1,638.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st106",
    points: "524.2,656 444.2,701.8 444.2,709.8 524.2,664  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st106",
    points: "493.4,693.4 444.2,721.5 444.2,729.6 493.4,701.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st106",
    points: "508,707.3 444.2,743.9 444.2,751.9 508,715.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st106",
    points: "493.4,634.4 444.2,662.8 444.2,670.9 493.4,642.5  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 383.9,
    y: 559.2,
    transform: "matrix(0.5026 -0.8645 0.8645 0.5026 -327.125 630.9243)",
    className: "st105",
    width: 1.6,
    height: 81
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M346.2,582.6c-2.7,0-4.8-2.2-4.8-4.8c0-2.7,2.2-4.8,4.8-4.8s4.8,2.2,4.8,4.8 C351.1,580.4,348.9,582.6,346.2,582.6z M346.2,574.7c-1.7,0-3.2,1.4-3.2,3.2c0,1.7,1.4,3.2,3.2,3.2c1.7,0,3.2-1.4,3.2-3.2 C349.4,576.1,348,574.7,346.2,574.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st104",
    points: "713.5,453.3 599.1,519.1 599.1,659.3 713.5,593.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M598.3,660.6v-142l116-66.7V594L598.3,660.6z M599.9,519.6v138.3L712.7,593V454.8L599.9,519.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st106",
    points: "687.4,506.3 623.6,542.8 623.6,550.9 687.4,514.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st106",
    points: "696.3,539.3 623.6,580.7 623.6,588.8 696.3,547.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st106",
    points: "678.4,569.5 623.6,600.9 623.6,609 678.4,577.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st106",
    points: "672.8,533.5 623.6,561.9 623.6,569.9 672.8,541.5  "
  })), /*#__PURE__*/React.createElement("rect", {
    x: 563.3,
    y: 458.3,
    transform: "matrix(0.5026 -0.8645 0.8645 0.5026 -150.6923 735.7687)",
    className: "st105",
    width: 1.6,
    height: 81
  }), /*#__PURE__*/React.createElement("path", {
    className: "st105",
    d: "M525.6,481.7c-2.7,0-4.8-2.2-4.8-4.8c0-2.7,2.2-4.8,4.8-4.8c2.7,0,4.8,2.2,4.8,4.8 C530.5,479.6,528.3,481.7,525.6,481.7z M525.6,473.7c-1.7,0-3.2,1.4-3.2,3.2c0,1.7,1.4,3.2,3.2,3.2c1.7,0,3.2-1.4,3.2-3.2 C528.8,475.2,527.4,473.7,525.6,473.7z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceElectreIllu);
export default __webpack_public_path__ + "static/media/service-electre-illu.6aebeb6c7c19f1fefb3578f9b305ef03.svg";
export { ForwardRef as ReactComponent };